<template>
    <div class="deals-sidebar">
        <div :class="['deals-sidebar__container', { 'is-show': isShowSidebar }]">
            <div class="deals-sidebar__button-close">
                <STBaseButton icon-after="IconCloseSmall"
                              icon-after-modify="icon-stroke icon_color_label"
                              modify="button_theme_reset button_close"
                              @click="removeSidebarInfo" />
            </div>

            <div class="deals-sidebar__content">
                <div class="deals-sidebar__title">
                    Информация о сделке
                </div>

                <div v-if="dealInfo?.contractDate"
                     class="deals-sidebar__block">
                    <div class="deals-sidebar__block-title">
                        Дата договора:
                    </div>
                    <div class="deals-sidebar__block-value">
                        {{ dealInfo.contractDate }}
                    </div>
                </div>

                <div v-if="dealInfo?.awardPercent || dealInfo?.awardPercent === 0"
                     class="deals-sidebar__block">
                    <div class="deals-sidebar__block-title">
                        Процент вознаграждения:
                    </div>
                    <div class="deals-sidebar__block-value">
                        {{ dealInfo.awardPercent }}%
                    </div>
                </div>

                <div v-if="!isHidePrice && (dealInfo?.awardSum || dealInfo?.awardSum === 0)"
                     class="deals-sidebar__block">
                    <div class="deals-sidebar__block-title">
                        Сумма вознаграждения:
                    </div>
                    <div class="deals-sidebar__block-value">
                        {{ dealInfo.awardSum | format }} ₽
                    </div>
                </div>

                <div v-if="dealInfo?.agencyName"
                     class="deals-sidebar__block">
                    <div class="deals-sidebar__block-title">
                        Наименование агентства:
                    </div>
                    <div class="deals-sidebar__block-value">
                        {{ dealInfo.agencyName }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import {DEALS_STATUSES} from '@/helpers/constants';

export default {
    name: 'DealsSidebar',

    filters: {
        format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 '),
    },

    props: {
        dealInfo: Object // Информация по сделке
    },

    data() {
        return {
            isShowSidebar: false
        };
    },

    computed: {
        isHidePrice() {
            const status = DEALS_STATUSES.find((item) => item.id?.toLowerCase() === this.dealInfo?.leadStatusId?.toLowerCase());

            return Boolean(status?.hidePrice);
        }
    },

    methods: {
        ...mapActions('deals', ['selectDeal']),

        showSidebar() {
            this.isShowSidebar = true;
        },

        hideSidebar() {
            this.isShowSidebar = false;
        },

        removeSidebarInfo() {
            this.hideSidebar();

            setTimeout(() => {
                this.selectDeal(null);
            }, 300);
        }
    }
};
</script>

<style lang="scss">
@import "DealsSidebar";
</style>
